var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderadd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/folderadd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.6527 41.9373V29.229M36.8543 35.5832H24.146",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.9168 27.9585V43.2085C55.9168 53.3752 53.3752 55.9168 43.2085 55.9168H17.7918C7.62516 55.9168 5.0835 53.3752 5.0835 43.2085V17.7918C5.0835 7.62516 7.62516 5.0835 17.7918 5.0835H21.6043C25.4168 5.0835 26.2556 6.20183 27.7043 8.1335L31.5168 13.2168C32.4827 14.4877 33.0418 15.2502 35.5835 15.2502H43.2085C53.3752 15.2502 55.9168 17.7918 55.9168 27.9585Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderadd);
export default __webpack_public_path__ + "static/media/folderadd.00a96156.svg";
export { ForwardRef as ReactComponent };